/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_References_Tools_Admin_Disabled_HintInputs */



/**
* | output |
* | --- |
* | "Your organisation has switched this integration off, so it cannot be linked here." |
*
* @param {Project_References_Tools_Admin_Disabled_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_references_tools_admin_disabled_hint = /** @type {((inputs?: Project_References_Tools_Admin_Disabled_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_References_Tools_Admin_Disabled_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ihre Organisation hat diese Integration deaktiviert, sie kann hier nicht verknüpft werden.")
	return /** @type {LocalizedString} */ ("Your organisation has switched this integration off, so it cannot be linked here.")
});